import { CarrierDriverMessageTable } from "../CarrierDriverMessageTable";
import { DataSource, Layout, SearchPanel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutCarrierDriverMessage extends Layout {
    layoutCarrierDriverMessageTable: CarrierDriverMessageTable;
    searchpanelFilters: SearchPanel;
    sourceCarrierDriverMessage: DataSource;
    textboxAssignedTo: Textbox;
    textboxCarrierId: Textbox;
    textboxDateRange: Textbox;
    textboxOperationsUser: Textbox;
    textboxOrderId: Textbox;
}
